import Service from '@ember/service';
import confetti from 'canvas-confetti';

export default class ConfettiService extends Service {
  play() {
    var myCanvas = document.createElement('canvas');
    myCanvas.className =
      'confetti fixed z-50 inset-0 h-full w-full pointer-events-none';
    document.body.appendChild(myCanvas);

    var myConfetti = confetti.create(myCanvas, {
      resize: true,
      useWorker: true,
    });
    myConfetti({
      particleCount: 100,
      spread: 160,
      origin: { y: 0.6 },

      // any other options from the global
      // confetti function
    }).finally(() => document.body.removeChild(myCanvas));
  }
}
